import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import styled from 'styled-components';
import { FdrAuthorDisrupter } from 'components/domain/fdr-blog-overview';

export const FdrBlogArticleSection = styled.div(
  sx2CssThemeFn({
    '.text-container': {
      px: [3, '200px'],
    },
  })
);

export const FdrEmployeeDisrupter = styled(FdrAuthorDisrupter)(
  sx2CssThemeFn({
    bottom: ['30px', '35px'],
    top: 'initial',
    left: ['0', '50%'],
    transform: [null, `translateX(-50%)`],
    maxWidth: '1480px',
    px: [3, '20px'],
    width: '100%',
  })
);
